(function (angular) {
    'use strict';

    angular.module("webChatReports")
        .controller("WebChatCtrl", [
            "$scope", '$stateParams', 'webChatService', 'growlService', 'chartsService', 'teams', '$timeout', 'sharedDataService', function ($scope, $stateParams, webChatService, growlService, chartsService, teams, $timeout, sharedDataService) {
                var timeout;
                var allTeams = {
                    name: 'All',
                    isAll: true
                };
                $scope.dates = [{
                    value: "Today",
                    name: "Today"
                }, {
                    value: "Yesterday",
                    name: "Yesterday"
                }, {
                    value: "7Days",
                    name: "This week"
                }, {
                    value: "Last7Days",
                    name: "Last week"
                }, {
                    value: "30Days",
                    name: "This month"
                }, {
                    value: "Last30Days",
                    name: "Last month"
                }, {
                    value: "Year",
                    name: "This year"
                }, {
                    value: "LastYear",
                    name: "Last year"
                }];

                $scope.getTime = function (seconds) {
                    var result;
                    var minutes = Math.floor(seconds / 60);
                    var hours = Math.floor(minutes / 60);
                    var restSeconds = seconds % 60;
                    if (hours > 0) {
                        result = ('00' + hours).substr(-2) + ":" + ('00' + minutes % 60).substr(-2) + ":" + ('00' + restSeconds).substr(-2) + 'h';
                    }
                    else if (minutes > 0) {
                        result = ('00' + minutes).substr(-2) + ":" + ('00' + restSeconds).substr(-2) + 'min';
                    }
                    else {
                        result = ('00' + restSeconds).substr(-2) + 'sec';
                    }
                    return result;
                };

                $scope.selectDate = function (date) {
                    $scope.selectedDateRange = date.value;
                    $scope.selectedDateRangeName = date.name;
                };

                $scope.teams = teams;
                $scope.pickedTeam = allTeams;
                $scope.pickTeam = function (team) {
                    $timeout.cancel(timeout);
                    $scope.liveData();
                    if (team == 'all') {
                        $scope.pickedTeam = allTeams;
                    }
                    else {
                        $scope.pickedTeam = team;
                    }
                    $scope.getData();
                };
                chartsService.setVariables([
                    { name: 'inbounds', displayName: 'Inbounds', color: '#009688', display: true },
                    { name: 'outbounds', displayName: 'Outbounds', color: '#2b98f0', display: true },
                    { name: 'closed', displayName: 'Closed', color: '#3aad50', display: true },
                    { name: 'responses', displayName: 'Responses', color: '#4caf50', display: false, hidden: true },
                    { name: 'timeToRespondSeconds', displayName: '', color: '', display: false, hidden: true },
                    { name: 'timeToInitialResponseSeconds', displayName: '', color: '', display: false, hidden: true },
                    { name: 'timeToCloseSeconds', displayName: '', color: '', display: false, hidden: true },
                    { name: 'initialResponses', displayName: '', color: '', display: false, hidden: true }
                ]);
                $scope.variables = chartsService.defaultVariables;

                $scope.startDateOptions = {
                    formatYear: 'yy',
                    startingDay: 1,
                    showWeeks: false
                };

                $scope.endDateOptions = {
                    formatYear: 'yy',
                    startingDay: 1,
                    showWeeks: false
                };

                $scope.open = function ($event, toOpen) {
                    $event.preventDefault();
                    $event.stopPropagation();
                    toOpen.opened = true;
                };

                $scope.getData = function () {
                    chartsService.setData($scope.query.from, $scope.query.to);
                    $scope.query.by = chartsService.getSampling();
                    webChatService.getQueriedData($stateParams.pickedApiSpaceId, chartsService.data, $scope.pickedTeam.id, sharedDataService.timeZone).then(function (result) {
                        var separateData = chartsService.separateData(result);
                        $scope.labels = separateData.labels;
                        $scope.allData = [];
                        $scope.extras = {};
                        for (var index in chartsService.defaultVariables) {
                            if (!chartsService.defaultVariables[index].hidden) {
                                var varName = chartsService.defaultVariables[index].name;
                                $scope.allData.push(separateData.variableData[varName]);
                                $scope.extras[varName] = separateData.variableSum[varName];
                            }
                        }
                        $scope.extras.avgResponseTime = Math.round(separateData.variableSum['responses'] > 0 ? separateData.variableSum['timeToRespondSeconds'] / separateData.variableSum['responses'] : 0);
                        $scope.extras.avgCloseTime = Math.round(separateData.variableSum['closed'] > 0 ? separateData.variableSum['timeToCloseSeconds'] / separateData.variableSum['closed'] : 0);
                        $scope.extras.avgInitialResponseTime = Math.round(separateData.variableSum['initialResponses'] > 0 ? separateData.variableSum['timeToInitialResponseSeconds'] / separateData.variableSum['initialResponses'] : 0);
                        $scope.displayVariables();
                        growlService.success('Data correctly downloaded ', 10, true);
                    }).catch(function (error) {
                        growlService.danger("Data didn't downloaded due to: " + error.statusText);
                    });
                };

                $scope.displayVariables = function (varIndex) {
                    var variables = chartsService.displayVariables(varIndex, $scope.allData);
                    $scope.series = variables.series;
                    $scope.data = variables.data;
                    $scope.colors = variables.colors;
                };

                $scope.datasetOverride = chartsService.datasetOverride();
                $scope.options = chartsService.options;
                $scope.query = {
                    from: {
                    },
                    to: {
                    }
                };
                var _selectedDateRange = "7Days";
                Object.defineProperty($scope, 'selectedDateRange', chartsService.selectedDateRange(_selectedDateRange, $scope.query, $scope.getData, {}));
                $scope.selectedDateRange = "7Days";
                $scope.selectedDateRangeName = "This week";
                $scope.liveData = function () {
                    $scope.liveExtras = {};
                    webChatService.getLiveData($stateParams.pickedApiSpaceId, $scope.pickedTeam.id).then(function (result) {
                        $scope.liveExtras.closed = result.closed ? result.closed : 0;
                        $scope.liveExtras.new = result.new ? result.new : 0;
                        $scope.liveExtras.replied = result.replied ? result.replied : 0;
                        timeout = $timeout($scope.liveData, 60000);
                    });
                };
                $scope.liveData();
            }
        ]);

})(window.angular);